import React from 'react';

const FullNameField = ({ record = {}, }) => (
    <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
        {record.first_name}&nbsp;{record.last_name}
    </div>
);

export default FullNameField;